import { useQuery } from '@tanstack/react-query';
import { fetchProjectPhoto } from '@apis/storage';
import { useObjectUrl } from '@hooks/useObjectUrl';

const ONE_HOUR_MS = 60 * 60 * 1000;

/**
 * An object URL for the project's photo, or null while it loads and when there
 * is none. Fetched per card, after the card has rendered, so the portfolio
 * never waits on photos. Not retried: a missing photo is the common case, not
 * a transient failure.
 */
export function useProjectPhoto(siteId: string): string | null {
  const query = useQuery<Blob | null>({
    queryKey: ['portfolio', 'project-photo', siteId],
    queryFn: ({ signal }) => fetchProjectPhoto(siteId, signal),
    staleTime: ONE_HOUR_MS,
    gcTime: ONE_HOUR_MS,
    retry: false,
  });
  return useObjectUrl(query.data);
}
